import React, { createContext, useContext, useState, useEffect } from 'react';
import en from './properties_EN.json';
import ru from './properties_RU.json';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('site_lang') || 'en';
    } catch (e) {
      return 'en';
    }
  });

  useEffect(() => {
    try { localStorage.setItem('site_lang', lang); } catch (e) {}
  }, [lang]);

  const strings = lang === 'ru' ? ru : en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, strings }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}

export default LanguageContext;
